export default __webpack_public_path__ + "static/media/pj-jogo-genius.ad7dc5d1.png";